import Debug   from './theme/debug.js';
import Helpers from './theme/helpers.js';

import GTMEvents from './theme/components/gtm-events.js';
import Fix100vh from './theme/components/fix100vh.js';
import Lazyload from './theme/components/lazyload.js';
import Viewport from './theme/components/viewport.js';
import AnimateScroll from './theme/components/animate-scroll';
import Delay from './theme/components/delay.js';
import Carousel from './theme/components/carousel.js';
import Lightbox from './theme/components/lightbox.js';
import Map from './theme/components/map.js';
import CopyLink from './theme/components/copy-link';
import OverlayNavigation from './theme/components/overlay-navigation';
import StickyHeader from './theme/components/sticky-header';
import Video from './theme/components/video.js';
import Tooltip from './theme/components/tooltip.js';
import Hero from './theme/components/hero.js';
import Livestream from './theme/components/livestream';
import Accordion from './theme/components/accordion';
import Modal from './theme/components/modal';
import WaitingList from './theme/components/waiting-list';
import Navigator from './theme/components/navigator';
import Floorplan from './theme/components/floorplan';
import StickyApartment from './theme/components/sticky-apartment';

window.theme = {
    globals: {
        isTouch: typeof window !== "undefined" && "ontouchstart" in window
    },
    init: function() {
        let theme = this;

        theme.debug = new Debug;
        theme.helpers = new Helpers;

        theme.gtmEvents = new GTMEvents(document).init();

        theme.fix100vh = new Fix100vh();
        theme.lazyload = new Lazyload();
        theme.viewport = new Viewport();
        theme.animateScroll = new AnimateScroll();
        theme.delay = new Delay();
        theme.lightbox = new Lightbox();
        theme.map = new Map();
        theme.livestream = new Livestream();
        theme.copyLink = new CopyLink;
        theme.overlayNavigation = new OverlayNavigation;
        theme.stickyHeader = new StickyHeader;
        theme.carousel = new Carousel;
        theme.video = new Video();
        theme.tooltip = new Tooltip();
        theme.hero = new Hero();
        theme.accordion = new Accordion();
        theme.modal = new Modal();
        theme.waitingList = new WaitingList();
        theme.navigator = new Navigator();
        theme.floorplan = new Floorplan();
        theme.stickyApartment = new StickyApartment();
    }
}

document.addEventListener('DOMContentLoaded', () => {
    theme.init();
}, false);
